import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    t="1578465477485"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4190"
    width="1em"
    height="1em"
  >
    <defs>
      <style type="text/css"></style>
    </defs>
    <path
      d="M1020.971209 436.646781L970.407366 91.729133a45.146289 45.146289 0 0 0-37.922883-37.922883L587.115372 1.436555a135.438867 135.438867 0 0 0-115.574499 38.374346l-431.598523 433.404374a135.438867 135.438867 0 0 0 0 191.420265l319.184263 319.184263a135.438867 135.438867 0 0 0 191.420265 0l432.501449-432.501448a135.438867 135.438867 0 0 0 37.922882-114.671574z m-310.606468-122.797906a90.292578 90.292578 0 1 1 127.763998 0 90.292578 90.292578 0 0 1-127.763998 0z"
      fill="#F2EFDC"
      p-id="4191"
    ></path>
    <path
      d="M754.608105 410.461933a135.438867 135.438867 0 1 0-135.438867-135.438867 135.438867 135.438867 0 0 0 135.438867 135.438867z m-60.044565-202.255375a90.292578 90.292578 0 0 1 15.801201-22.121681 90.292578 90.292578 0 1 1 127.763998 127.763998l-4.063166 3.611703a90.292578 90.292578 0 1 1-139.502033-108.802557z"
      fill="#CECAB7"
      p-id="4192"
    ></path>
    <path
      d="M777.181249 387.888788a135.438867 135.438867 0 1 1 135.438867-135.438866 135.438867 135.438867 0 0 1-135.438867 135.438866z m0-225.731444a90.292578 90.292578 0 1 0 90.292578 90.292578 90.292578 90.292578 0 0 0-90.292578-90.292578z"
      fill="#E85A2E"
      p-id="4193"
    ></path>
  </svg>
);

const IconPrice = (props) => <Icon component={icon} {...props} />;

export default IconPrice;
